import { BUTTON_TYPES } from '../components/ShowContactByDataPoint/constants';

export const buildContactsDataPointDataForShow = (contacts, selectedDataPointType) => contacts.map(({ id: inputId, maskedContactId, emails, phones }) => {
  const emailIds =
    (selectedDataPointType === BUTTON_TYPES.EMAIL_AND_PHONE || selectedDataPointType === BUTTON_TYPES.EMAIL)
      ? emails.filter(email => email.status === 'masked' && email.id !== null).map(email => email.id)
      : [];

  const phoneIds =
    (selectedDataPointType === BUTTON_TYPES.EMAIL_AND_PHONE || selectedDataPointType === BUTTON_TYPES.PHONE)
      ? phones.filter(phone => phone.status === 'masked' && phone.id !== null).map(phone => phone.id)
      : [];

  if (emailIds.length > 0 || phoneIds.length > 0) {
    return {
      contact_input_id: inputId,
      contact_id: maskedContactId,
      email_data_points_ids: emailIds,
      phone_data_points_ids: phoneIds,
    };
  }

  return null;
});

export const sumNumberOfCreditsCharge = contacts => contacts?.reduce((sum, contact) => {
  // if there are any email / phone ids, we charge one credit for email and 5 credits for phone
  const emailLength = contact?.email_data_points_ids?.length > 0 ? 1 : 0;
  const phoneLength = contact?.phone_data_points_ids?.length > 0 ? 5 : 0;

  return sum + emailLength + phoneLength;
}, 0);
